export function hmrSafeSingleton<T>(key: string, singleton: T) {
  return (
    (import.meta.hot?.data?.[key] as T | undefined) ??
    (import.meta.hot?.data ? (import.meta.hot.data[key] = singleton) : singleton)
  );
}
